import { render } from "./wishlist.vue?vue&type=template&id=dac9f052&scoped=true"
import script from "./wishlist.vue?vue&type=script&lang=js"
export * from "./wishlist.vue?vue&type=script&lang=js"

import "./wishlist.vue?vue&type=style&index=0&id=dac9f052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dac9f052"]])

export default __exports__